import i18next from "i18next";

export const useI18n = () => {
  const t = (key: string, options?: any): string => {
    if (process.env.NODE_ENV === "development") {
      return `# ${i18next.t(key, options)}`;
    }
    return i18next.t(key, options);
  };

  const changeLanguage = async (lng: string) => {
    await i18next.changeLanguage(lng);
  };

  const changeNamespace = async (ns: string) => {
    await i18next.loadNamespaces(ns);
  };

  return {
    t,
    currentLanguage: i18next.language,
    changeLanguage,
    changeNamespace,
    isReady: i18next.isInitialized,
    i18n: i18next
  };
};
